import React, { useState, useEffect, useRef, useCallback } from "react";

import {
  Card,
  CardContent,
  Typography,
  Container,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  useMediaQuery,
  TextField,
  IconButton,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@mui/material";
import ExcelJS from "exceljs";
import CircularProgress from "@mui/material/CircularProgress";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
  limit,
  startAfter,
  Timestamp,
  or,
  and,
  doc,
  updateDoc,
  serverTimestamp,
  getDoc
} from "firebase/firestore/lite";
import SearchBar from "./SearchBar";
import { Link, useNavigate } from "react-router-dom";
import "../style.css";
import Banner from "./Banner";
import InfiniteScroll from "react-infinite-scroll-component";
import SoftBox from "./SoftBox";
import Bill from "./Bill";
import SoftButton from "./SoftButton";
import "@amir04lm26/react-modern-calendar-date-picker/lib/DatePicker.css";
import DatePicker from "@amir04lm26/react-modern-calendar-date-picker";
import SoftTypography from "./SoftTypography";
import CloseIcon from "@material-ui/icons/Close";
import SwapHorizIcon from "@material-ui/icons/SwapHoriz";
import MiniStatisticsCard from "./Cards/StatisticsCards/MiniStatisticsCard";
import { RotatingLines } from "react-loader-spinner";
import MySpinner from "./MySpinner";
import updateUserAssessment from "../globals/db-updates"
import { getTotalTime } from "../globals/utils";
// import Tooltip from '@mui/material/Tooltip';

const CardLayout1 = ({ row }) => {
  const { resultStatus } = row;
  let status = "";

  let showCodeGenerated = false;
  switch (resultStatus) {
    case "CEFR":
    case "Pending":
    case "Complete":
      status = "";
      break;
    case "Screened":
      status = "Screened";
      break;
    case "Passed":
      status = "Screened - Pass";
      break;
    case "Rejected":
      status = "Screened - Reject";
      break;
    default:
      let dateString = null;
      const date = new Date(row.createdAt.seconds * 1000);
      dateString = date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "2-digit",
      });
      if (row.test_completion) {
        status = "In Re-Assessment";
      } else {
        status = "Code Generated on " + dateString;
      }

      showCodeGenerated = true;
      break;
  }

  let statusColor = "gt_primary"; // Default color
    if (status === "Screened - Pass") {
    statusColor = "green";
  } else if (status === "Screened - Reject") {
    statusColor = "red";
  } else if (status === "Screened") {
    statusColor = "gt_primary";
  }
  const name = row.firstName + " " + row.lastName;

  return (
    <Bill
      showCodeGenerated={showCodeGenerated}
      status={status}
      statusColor={statusColor}
      name={name}
      email={row.email}
      phone={row.phoneNumber || row.phone}
      completion={row.test_completion}
      row={row}
      createdDate={row.createdAt}
      region={row.region}
      testName={row.test_name}
    />
  );
};

const getLoader = () => {
  return (<RotatingLines
    strokeColor="black"
    strokeWidth="5"
    animationDuration="0.75"
    width="96"
    visible={true}
  />)
}
const CandidateList = () => {

  const [regions, setRegions] = useState([]);
  const [percentageScore, setPercentageScore] = useState([]);
  const [cefrScore, setCefrScore] = useState([]);
  const [usersScreened, setUsersScreened] = useState([]);
  const [usersPassed, setUsersPassed] = useState([]);
  const [usersRejected, setUsersRejected] = useState([]);

  const [hasMore, setHasMore] = useState(true);
  const hasMoreRef = useRef(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [users, setUsers] = useState([]);
  const [isBottom, setIsBottom] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const isLoadingRef = useRef(false);
  const [isStatsLoading, setIsStatsLoading] = useState(false);

  const [endDoc, setEndDoc] = useState(null);
  const [page, setPage] = useState(1);
  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [isNotScreenedChecked, setIsNotScreenedChecked] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([
    "Rejected",
    "Passed",
    "Screened",
    "All",
  ]);
  const [selectedDayRange, setSelectedDayRange] = useState({
    from: null,
    to: null,
  });
  const [selectedEffectiveDayRange, setSelectedEffectiveDayRange] = useState({
    from: null,
    to: null,
  });
  // const [selectedRegion, setSelectedRegion] = useState("");

  const [selectedModalRegion, setSelectedModalRegion] = useState("");
  const [stats, setStats] = useState({ screened: 0, passed: 0, rejected: 0 });

  const [filter, setFilter] = useState("");
  const history = useNavigate();

  const [open, setOpen] = useState(false);
  const [showDatePicker, setShowDatePicker] = React.useState(false);
  const [activeFilter, setActiveFilter] = useState(null);

  const [filterOpen1, setFilterOpen1] = useState(false);
  const [filterOpen2, setFilterOpen2] = useState(false);
  const [filterOpen3, setFilterOpen3] = useState(false);
  const selectRef1 = useRef(null);
  const selectRef2 = useRef(null);
  const selectRef3 = useRef(null);

  // Keep refs in sync with state so scroll handler always sees current values
  useEffect(() => { isLoadingRef.current = isLoading; }, [isLoading]);
  useEffect(() => { hasMoreRef.current = hasMore; }, [hasMore]);

  useEffect(() => {
    const handleScroll = () => {
      setFilterOpen1(false);
      setFilterOpen2(false);
      setFilterOpen3(false);
    };
  
    const handleKeydown = (event) => {
      const scrollKeys = ["ArrowUp", "ArrowDown", "PageUp", "PageDown", "Home", "End"];
      if (scrollKeys.includes(event.key)) {
        setFilterOpen1(false);
        setFilterOpen2(false);
        setFilterOpen3(false);
      }
    };
  
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("wheel", handleScroll);
    window.addEventListener("touchmove", handleScroll);
    window.addEventListener("keydown", handleKeydown);
  
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("wheel", handleScroll);
      window.removeEventListener("touchmove", handleScroll);
      window.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  const toggleDatePicker = () => {
    setShowDatePicker(!showDatePicker);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const chunkArray = (array, size) => {
    const chunkedArray = [];
    for (let i = 0; i < array.length; i += size) {
      chunkedArray.push(array.slice(i, i + size));
    }
    return chunkedArray;
  };


  const exportSelected = async () => {
    setIsStatsLoading(true);

    const combinedList = [...usersScreened, ...usersPassed, ...usersRejected];
    const resultsUserIds = [];
    const usersMap = {};
    const userArray = combinedList.map((user) => {
      if (user.resultStatus === "Passed" || user.resultStatus === "Screened"
        || user.resultStatus === "Rejected") {
        resultsUserIds.push(user.id);
      }

      usersMap[user.id] = user;

      return user;
    });

    const chunkedResultsUserIds = chunkArray(resultsUserIds, 29);

    const chunk1 = ['877618', '304436']
    const qx = query(
      collection(db, "assessments"),
      where("userId", "in", chunk1),
      orderBy("createdAt", "desc"),
      limit(20)
    );

    const assessmentSnapshot1 = await getDocs(qx);
    assessmentSnapshot1.docs.forEach((doc) => {
      const assessment = doc.data();
      assessment.id = doc.id;

      const userId = assessment.userId;
      if (usersMap[userId]) {
        if (!usersMap[userId].assessments) {
          usersMap[userId].assessments = [];
        }
      }
    });

    for (const chunk of chunkedResultsUserIds) {
      const q2 = query(
        collection(db, "assessments"),
        where("userId", "in", chunk),
        orderBy("createdAt", "desc"),
      );
      const assessmentSnapshot = await getDocs(q2);

      assessmentSnapshot.docs.forEach((doc) => {
        const assessment = doc.data();
        assessment.id = doc.id;
        const userId = assessment.userId;

        if (usersMap[userId]) {
          if (!usersMap[userId].assessments) {
            usersMap[userId].assessments = [];
          }
          usersMap[userId].assessments.push(assessment);
        }

      });
    }

    await exportToExcel(userArray)
    setIsStatsLoading(false);
  };

  const exportAll = async () => {
    setIsStatsLoading(true);
    const q1 = query(
      collection(db, "users"),
      where("userType", "==", "Candidate"),
      orderBy("createdAt", "desc")
    );

    try {
      const userSnapshot = await getDocs(q1);
      const resultsUserIds = [];
      const usersMap = {};
      const userArray = userSnapshot.docs.map((doc) => {
        const user = doc.data();
        user.id = doc.id;

        if (user.resultStatus === "Passed" || user.resultStatus === "Screened"
          || user.resultStatus === "Rejected") {
          resultsUserIds.push(user.id);
        }

        usersMap[user.id] = user;

        return user;
      });

      const chunkedResultsUserIds = chunkArray(resultsUserIds, 29);

      for (const chunk of chunkedResultsUserIds) {
        const q2 = query(
          collection(db, "assessments"),
          where("userId", "in", chunk),
          orderBy("createdAt", "desc"),
        );
        const assessmentSnapshot = await getDocs(q2);

        assessmentSnapshot.docs.forEach((doc) => {
          const assessment = doc.data();
          assessment.id = doc.id;

          const userId = assessment.userId;
          if (usersMap[userId]) {
            if (!usersMap[userId].assessments) {
              usersMap[userId].assessments = [];
            }
            usersMap[userId].assessments.push(assessment);
          }
        });
      }

      await exportToExcel(userArray)
      setIsStatsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsStatsLoading(false);
    }
  };


  // Assuming user and assessment data are already fetched and stored in variables userArray and assessmentArray

  // Function to calculate the average of three scores
  const calculateAverage = (score1, score2, score3) => {
    const total = Number(score1) + Number(score2) + Number(score3);
    const average = total / 3;
    return average.toFixed(2);
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp * 1000);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear() % 100;

    return `${month}/${day}/${year}`;
  };

  // Function to export data to Excel
  const exportToExcel = async (userArray) => {

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Candidates");

    // Define the headers for the worksheet
    worksheet.columns = [
      { header: "Email", key: "email" },
      { header: "Full Name", key: "fullName" },
      { header: "Phone", key: "phone" },
      { header: "Region", key: "region" },
      { header: "date", key: "testCompletionDate" },
      { header: "Listening Score", key: "listeningScore" },
      { header: "Vocabulary Score", key: "vocabScore" },
      { header: "Reading Similarity Score", key: "readingSimilarity" },
      { header: "Avg Score", key: "avgScore" },
      { header: "Total Time", key: "totalTime" },
      { header: "Attempts", key: "attempts" },
      { header: "Results", key: "results" },
      { header: "Feedback", key: "feedback" },
    ];

    const dataToExport = userArray.map((user) => {
      const userId = user.id;
      const fullName = user.firstName + " " + user.lastName;
      const totalAttempts = user.assessments ? user.assessments.length : 0;


      const resultStatus = user.resultStatus
      let feedback;
      let assessment;

      let listeningScore = "";
      let vocabScore = "";
      let readingSimilarity = "";
      let scores = ""
      let testCompletionDate = "";
      let averageScore = ""
      let attempts = "";
      let totalTime = ""
      let result1 = ""
      if (resultStatus === 'Initial') {

      } else {
        result1 =
          user.resultStatus === "Screened" ? "Screened" : user.isPass ? "Passed" : "Rejected";

        if (user.assessments && user.assessments.length > 0) {
          assessment = user.assessments.find((a) => a.resultStatus);
          if (assessment) {
            feedback = assessment.feedback;
          }
        }
        testCompletionDate = formatDate(user.test_completion?.seconds);

        listeningScore = !isNaN(parseFloat(assessment?.listeningScore)) ? parseFloat(assessment?.listeningScore) : "";
        vocabScore = !isNaN(parseFloat(assessment?.vocabScore)) ? parseFloat(assessment?.vocabScore) : "";
        readingSimilarity = !isNaN(parseFloat(assessment?.reading_similarity)) ? parseFloat(assessment?.reading_similarity) : "";
        const score1 = (readingSimilarity + vocabScore + listeningScore);
        averageScore = (score1 / 3).toFixed(2);

        const totalSeconds = user.test_completion ? user.test_completion.seconds : 0;
        const totalMinutes = Math.floor(totalSeconds / 60);
        const totalHours = Math.floor(totalMinutes / 60);

        totalTime = assessment ? getTotalTime(assessment) : ''
        attempts = user.assessments ? user.assessments.length : 0;

      }

      const result = "N/A";
      worksheet.addRow({
        email: user.email,
        fullName: `${user.firstName} ${user.lastName}`,
        phone: user.phoneNumber || user.phone,
        region: user.region,
        testCompletionDate: testCompletionDate,
        listeningScore: listeningScore,
        vocabScore: vocabScore,
        readingSimilarity: readingSimilarity,
        avgScore: averageScore,
        totalTime: totalTime,
        attempts: attempts,
        results: result1,
        feedback: feedback,
      });

      return {
        email: user.email,
        fullName,
        phone: user.phoneNumber || user.phone,
        region: user.region,
        testCompletionDate: testCompletionDate,
        listeningScore,
        vocabScore,
        readingSimilarity,
        averageScore,
        totalTime,
        totalAttempts,
        resultStatus: result1,
        feedback,
      };


    });
    // Generate the Excel file
    const buffer = await workbook.xlsx.writeBuffer();

    // Create a Blob from the buffer
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

    // Save the Blob as a file
    const fileName = "candidates.xlsx";
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    // console.log(dataToExport);
  };


  // if (isLoading) return (getLoader()) 

  const getModalDiv = () => {
    return (
      <div>
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
          <DialogTitle>
            Statistics
            <CloseIcon
              style={{ float: "right", cursor: "pointer" }}
              onClick={handleClose}
            />
          </DialogTitle>
          <DialogContent
            style={{
              width: "80vh%",
              height: "70vh",
            }}
          >
            {getModalFilter()}
            <SoftBox py={3}>
              <SoftBox mb={3}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} xl={4}>
                    {isStatsLoading ? (
                      <CircularProgress color="gt_primary" />
                    ) : (
                      <MiniStatisticsCard
                        title={{ text: "Screened" }}
                        count={stats.screened}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} sm={4} xl={4}>
                    {isStatsLoading ? (
                      <CircularProgress color="gt_primary" />
                    ) : (
                      <MiniStatisticsCard
                        title={{ text: "Passed" }}
                        count={stats.passed}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} sm={4} xl={4}>
                    {isStatsLoading ? (
                      <CircularProgress color="gt_primary" />
                    ) : (
                      <MiniStatisticsCard
                        title={{ text: "Rejected" }}
                        count={stats.rejected}
                      />
                    )}
                  </Grid>
                </Grid>
              </SoftBox>
            </SoftBox>
          </DialogContent>
          {isStatsLoading ? (
            <DialogActions>
              <CircularProgress />
            </DialogActions>
          ) : (
            <>
              <DialogActions>
                <SoftButton onClick={exportSelected} color="gt_primary">
                  Export
                </SoftButton>
                <SoftButton onClick={exportAll} color="gt_primary">
                  Export All
                </SoftButton>

                <SoftButton onClick={handleClose} color="gt_primary">
                  Close
                </SoftButton>
              </DialogActions>
            </>
          )}
        </Dialog>
      </div>
    );
  };

  async function searchUsers(searchQuery) {
    const st = searchQuery + "\uf8ff";
    setUsers([]);

    setIsLoading(true);

    const firstNameQuery = query(
      collection(db, "users"),
      where("userType", "==", "Candidate"),
      where("firstNameSearch", ">=", searchQuery.toLowerCase()),
      where("firstNameSearch", "<=", st.toLowerCase()),
      orderBy("firstNameSearch", "desc"),
      orderBy("createdAt", "desc"),
      limit(pageSize)
    );

    const lastNameQuery = query(
      collection(db, "users"),
      where("userType", "==", "Candidate"),
      where("lastNameSearch", ">=", searchQuery.toLowerCase()),
      where("lastNameSearch", "<=", st.toLowerCase()),
      orderBy("lastNameSearch", "desc"),
      orderBy("createdAt", "desc"),
      limit(pageSize)
    );

    const phoneNumberQuery = query(
      collection(db, "users"),
      where("userType", "==", "Candidate"),
      where("phoneNumber", ">=", searchQuery),
      where("phoneNumber", "<=", st),
      orderBy("phoneNumber", "desc"),
      orderBy("createdAt", "desc"),
      limit(pageSize)
    );

    const phoneQuery = query(
      collection(db, "users"),
      where("userType", "==", "Candidate"),
      where("phone", ">=", searchQuery),
      where("phone", "<=", st),
      orderBy("phone", "desc"),
      orderBy("createdAt", "desc"),
      limit(pageSize)
    );

    const emailQuery = query(
      collection(db, "users"),
      where("userType", "==", "Candidate"),
      where("email", ">=", searchQuery),
      where("email", "<=", st),
      orderBy("email", "desc"),
      orderBy("createdAt", "desc"),
      limit(pageSize)
    );

    const [
      firstNameResults,
      lastNameResults,
      phoneNumberResults,
      phoneResults,
      emailResults,
    ] = await Promise.all([
      getDocs(firstNameQuery),
      getDocs(lastNameQuery),
      getDocs(phoneNumberQuery),
      getDocs(phoneQuery),
      getDocs(emailQuery),
    ]);

    const mergedResults = mergeQueryResults(
      firstNameResults,
      lastNameResults,
      phoneNumberResults,
      phoneResults,
      emailResults
    );

    function mergeQueryResults(...results) {
      const merged = [];
      let i = 0;

      while (i < pageSize && results.some((result) => result.docs[i])) {
        const docs = results.filter((result) => result.docs[i]);

        const doc = docs.reduce((prev, curr) => {
          const fieldPath = curr.query?._fieldPath?.segments[0];
          if (
            fieldPath &&
            curr.docs[i].data()[fieldPath] > prev.data()[fieldPath]
          ) {
            return curr.docs[i];
          }
          return prev;
        }, docs[0].docs[i]);

        merged.push(doc);
        i++;
      }
      return merged;
    }

    const userArray = mergedResults.map((doc) => {
      const user = doc.data();
      user.id = doc.id;
      return user;
    });

    // Fetch typing WPM from assessments for search results
    const completedSearchUsers = userArray.filter((u) => u.test_completion);
    if (completedSearchUsers.length > 0) {
      const uids = completedSearchUsers.map((u) => u.uid || u.id);
      for (let i = 0; i < uids.length; i += 30) {
        const chunk = uids.slice(i, i + 30);
        try {
          const aq = query(
            collection(db, "assessments"),
            where("userId", "in", chunk)
          );
          const aSnap = await getDocs(aq);
          aSnap.docs.forEach((aDoc) => {
            const aData = aDoc.data();
            const typingData = aData.typing_test;
            if (typingData && typingData.length > 0 && typingData[0].wpm !== undefined) {
              const user = userArray.find((u) => (u.uid || u.id) === aData.userId);
              if (user) user.typing_wpm = typingData[0].wpm;
            }
          });
        } catch (e) {
          console.error("Error fetching typing WPM:", e);
        }
      }
    }

    setUsers((prevUsers) => [...prevUsers, ...userArray]);

    setIsLoading(false);
    setHasMore(false);
    return mergedResults;
  }

  const fetchSignedUrl = async (filename) => {
    try {
      const apiUrl = `${process.env.REACT_APP_SERVER_URL}/get_signed_url?filename=${filename}`;
      const options = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const response = await fetch(apiUrl, options);
      const data = await response.json();
      return data.signed_url || null;
    } catch (error) {
      console.error('Error fetching signed URL:', error);
      return null;
    }
  };

  const pageSize = 25;

  const loadData = useCallback(
    async (
      filterValue,
      filterTypes1,
      region,
      percentage,
      cefr,
      endDoc,
      clearResults,
      range
    ) => {
      let q = query(collection(db, "users"), where("userType", "==", "Candidate"));

      const hasPercentageFilter = percentage && percentage.length > 0;
      const hasRegionFilter = region && region.length > 0 && !region.includes("All");
      const hasCefrFilter = cefr && cefr.length > 0;
      let hasOrderedByPercentage = false;

      // Apply Percentage Filter
      if (hasPercentageFilter) {
        const ranges = percentage
          .map((p) => {
            switch (p) {
              case 0: return [0, 20];
              case 20: return [21, 40];
              case 40: return [41, 60];
              case 60: return [61, 80];
              case 80: return [81, 100];
              default: return null;
            }
          })
          .filter(Boolean);

        if (ranges.length === 1) {
          q = query(q, where("calculated_percentage", ">=", ranges[0][0]));
          q = query(q, where("calculated_percentage", "<=", ranges[0][1]));
        } else {
          const orQueries = ranges.map(([min, max]) =>
            and(where("calculated_percentage", ">=", min), where("calculated_percentage", "<=", max))
          );
          q = query(q, or(...orQueries));
        }

        q = query(q, orderBy("calculated_percentage"));
        q = query(q, orderBy("lastUpdatedOn", "desc"));
        hasOrderedByPercentage = true;
      }

      // Apply Region Filter
      if (hasRegionFilter) {
        q = query(q, where("region", "in", region));
      }

      // Apply CEFR Filter
      if (hasCefrFilter) {
        q = query(q, where("cefr_score", "in", cefr));
      }

      // Special Cases
      if (filterValue === "not_screened") {
        q = query(q, where("currentStep", "!=", "Finish"));
        q = query(q, orderBy("currentStep", "desc"));
      }

      if (filterValue === "codeGenerated") {
        q = query(q, where("resultStatus", "==", "Initial"));
        q = query(q, where("currentStep", "==", "BEGIN_TEST"));
      }

      // Order by lastUpdatedOn if not already applied
      if (!hasOrderedByPercentage) {
        q = query(q, orderBy("lastUpdatedOn", "desc"));
      }

      // Pagination
      if (endDoc) {
        q = query(q, startAfter(endDoc));
      }

      q = query(q, limit(pageSize));

      if (clearResults) setUsers([]);

      try {
        const userSnapshot = await getDocs(q);
        const userArray = userSnapshot.docs.map((doc) => {
          const user = doc.data();
          user.id = doc.id;
          return user;
        });

        // Fetch typing WPM from assessments for these users
        const completedUsers = userArray.filter((u) => u.test_completion);
        if (completedUsers.length > 0) {
          const uids = completedUsers.map((u) => u.uid || u.id);
          // Firestore 'in' supports max 30
          for (let i = 0; i < uids.length; i += 30) {
            const chunk = uids.slice(i, i + 30);
            try {
              const aq = query(
                collection(db, "assessments"),
                where("userId", "in", chunk)
              );
              const aSnap = await getDocs(aq);
              aSnap.docs.forEach((aDoc) => {
                const aData = aDoc.data();
                const typingData = aData.typing_test;
                if (typingData && typingData.length > 0 && typingData[0].wpm !== undefined) {
                  const user = userArray.find((u) => (u.uid || u.id) === aData.userId);
                  if (user) user.typing_wpm = typingData[0].wpm;
                }
              });
            } catch (e) {
              console.error("Error fetching typing WPM:", e);
            }
          }
        }

        // Avoid duplicates
        setUsers((prevUsers) => {
          const combinedUsers = [...prevUsers, ...userArray];
          return Array.from(new Map(combinedUsers.map((u) => [u.id, u])).values());
        });

        if (userArray.length > 0) {
          const lastDoc = userSnapshot.docs[userSnapshot.docs.length - 1];
          setEndDoc(lastDoc);
          setHasMore(userArray.length >= pageSize);
        } else {
          // No more data to load
          setHasMore(false);
        }

        // Collect pending users for background processing AFTER page load completes
        const incompleteUsers = userArray.filter(
          (user) => user.currentStep === "Finish" && user.resultStatus === "Pending"
        );

        if (incompleteUsers.length > 0) {
          // Delay ML scoring so it doesn't compete with page load
          setTimeout(() => {
            processPendingUsers(incompleteUsers);
          }, 5000);
        }
      } catch (error) {
        console.error("Error loading users:", error);
        setHasMore(false);
      }

      setIsLoading(false);
      isLoadingRef.current = false; // Reset guard so InfiniteScroll can trigger next load
    },
    [db, pageSize]
  );

  const processPendingUsers = async (incompleteUsers) => {
    console.log(`[Background] Processing ${incompleteUsers.length} pending users for ML scoring...`);
    const speakingSteps = ["speaking_topic", "speaking_intro", "speaking_interaction"];

    for (const user of incompleteUsers) {
      try {
        if (!user.uid || typeof user.uid !== "string") continue;

        // Small delay between users so we don't overwhelm the backend
        await new Promise((resolve) => setTimeout(resolve, 1000));

        const assessmentQuery = query(
          collection(db, "assessments"),
          where("userId", "==", user.uid)
        );
        const assessmentSnap = await getDocs(assessmentQuery);
        if (assessmentSnap.empty) continue;

        const assessmentDoc = assessmentSnap.docs[0];
        const assessmentId = assessmentDoc.id;
        let assessment = assessmentDoc.data();

        // Skip if resultStatus is not Pending
        if (assessment?.resultStatus !== "Pending") continue;

        // Detect if this is an audio scenario assessment (no CEFR speaking sections)
        const hasAudioScenarioSections = Object.keys(assessment).some(
          (key) => key.startsWith("audio_scenario_") && key.endsWith("_audio_url")
        );
        const hasCefrSpeakingSections = speakingSteps.some(
          (step) => assessment?.[`${step}_audio_url`] !== undefined
        );

        // WRITING SCORE
        const hasWritingScore = assessment?.cefr_writing_score !== undefined && assessment?.cefr_writing_score !== null;

        if (!hasWritingScore && assessment?.cefr_writing) {
          const cefrAnswers = assessment?.cefr_writing;
          const validAnswers = Array.isArray(cefrAnswers)
            ? cefrAnswers
                .map((entry) =>
                  typeof entry.answer === "string"
                    ? entry.answer.trim()
                    : String(entry.answer || "")
                )
                .filter((ans) => ans.length > 0)
            : [];

          if (validAnswers.length >= 2) {
            try {
              await fetch(`${process.env.REACT_APP_SERVER_URL}/update_grammar_scores`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  assessment_uid: assessmentId,
                  current_step: "cefr_writing",
                  answers: validAnswers,
                  // CDT-309: this is a recruiter-side rescore of an existing
                  // record. It used to avoid advancing the candidate purely by
                  // virtue of sending current_step; that is now explicit.
                  advance: false,
                }),
              });
            } catch (error) {
              console.error(`Error updating grammar scores for ${user.id}:`, error);
            }
          }
        }

        // SPEAKING SCORES — only process if assessment has CEFR speaking sections
        if (hasCefrSpeakingSections) {
          const speakingScoresPresent = speakingSteps.every(
            (step) =>
              assessment?.[`${step}_score`] !== undefined &&
              assessment?.[`${step}_score`] !== null
          );

          if (!speakingScoresPresent) {
            for (const step of speakingSteps) {
              const scoreExists =
                assessment?.[`${step}_score`] !== undefined &&
                assessment?.[`${step}_score`] !== null;
              if (scoreExists) continue;

              const audioFilename = assessment[`${step}_audio_url`];
              const passage = assessment?.passage || "";

              if (!audioFilename) continue;

              try {
                const existingTranscript = assessment[`${step}_transcribe`];

                const formData = new FormData();
                formData.append("assessment_uid", assessmentId);
                formData.append("passage", passage);
                formData.append("user_id", user.uid);
                formData.append("current_step", step);
                formData.append("nextStep", user.currentStep);

                // Try to fetch audio, but don't fail if unavailable
                const audioResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/${audioFilename}`);
                if (audioResp.ok) {
                  const audioBlob = await audioResp.blob();
                  formData.append("audio", audioBlob);
                }

                if (existingTranscript) {
                  formData.append("transcribed_text", existingTranscript);
                }

                // Only call update_transcribe if we have audio or transcript
                if (audioResp.ok || existingTranscript) {
                  await fetch(`${process.env.REACT_APP_SERVER_URL}/update_transcribe`, {
                    method: "POST",
                    body: formData,
                  });
                }
              } catch (error) {
                console.error(`Error during transcription for ${user.id} — ${step}:`, error);
              }
            }
          }
        }

        // AUDIO SCENARIO SCORES — process if assessment has audio scenario sections
        if (hasAudioScenarioSections) {
          const audioScenarioSteps = Object.keys(assessment)
            .filter((key) => key.startsWith("audio_scenario_") && key.endsWith("_audio_url"))
            .map((key) => key.replace("_audio_url", ""));

          for (const step of audioScenarioSteps) {
            const scoreExists =
              assessment?.[`${step}_score`] !== undefined &&
              assessment?.[`${step}_score`] !== null;
            if (scoreExists) continue;

            const audioFilename = assessment[`${step}_audio_url`];
            if (!audioFilename) continue;

            try {
              const existingTranscript = assessment[`${step}_transcribe`];

              const formData = new FormData();
              formData.append("assessment_uid", assessmentId);
              formData.append("passage", "");
              formData.append("user_id", user.uid);
              formData.append("current_step", step);
              formData.append("nextStep", user.currentStep);

              // Try to fetch audio, but don't fail if unavailable
              const audioResp = await fetch(`${process.env.REACT_APP_SERVER_URL}/${audioFilename}`);
              if (audioResp.ok) {
                const audioBlob = await audioResp.blob();
                formData.append("audio", audioBlob);
              }

              if (existingTranscript) {
                formData.append("transcribed_text", existingTranscript);
              }

              // Only call update_transcribe if we have audio or transcript
              if (audioResp.ok || existingTranscript) {
                await fetch(`${process.env.REACT_APP_SERVER_URL}/update_transcribe`, {
                  method: "POST",
                  body: formData,
                });
              }
            } catch (error) {
              console.error(`Error during transcription for ${user.id} — ${step}:`, error);
            }
          }
        }

        // REFETCH ASSESSMENT AFTER ANY CHANGES
        const updatedDoc = await getDoc(doc(db, "assessments", assessmentId));
        const updatedAssessment = updatedDoc.data();

        // BUILD REQUIRED SCORES DYNAMICALLY based on what sections the assessment has
        const requiredScores = [];

        // Only require writing score if the assessment has writing answers
        if (updatedAssessment?.cefr_writing) {
          requiredScores.push("cefr_writing_score");
        }

        // Only require CEFR speaking scores if the assessment has CEFR speaking sections
        if (hasCefrSpeakingSections) {
          requiredScores.push("speaking_topic_score", "speaking_intro_score", "speaking_interaction_score");
        }

        // Require audio scenario scores if the assessment has audio scenario sections
        if (hasAudioScenarioSections) {
          const scenarioScoreKeys = Object.keys(updatedAssessment)
            .filter((key) => key.startsWith("audio_scenario_") && key.endsWith("_audio_url"))
            .map((key) => key.replace("_audio_url", "_score"));
          requiredScores.push(...scenarioScoreKeys);
        }

        const hasAllScores = requiredScores.length > 0 && requiredScores.every((key) => {
          const val = updatedAssessment[key];
          return val !== undefined && val !== null;
        });

        const isStillPending = updatedAssessment?.resultStatus === "Pending";

        if (hasAllScores && isStillPending) {
          try {
            const statusResponse = await fetch(
              `${process.env.REACT_APP_SERVER_URL}/update_assessment_status`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  assessmentUid: assessmentId,
                  testName: updatedAssessment?.testName || "default_test",
                }),
              }
            );

            if (statusResponse.ok) {
              console.log(`Final Assessment status updated for user ${user.id}`);
            } else {
              console.warn(`Final Status update failed for user ${user.id}`);
            }
          } catch (error) {
            console.error(`Error calling update_assessment_status for ${user.id}:`, error);
          }
        }
      } catch (error) {
        console.error(`Error processing user ${user.id}:`, error);
      }
    }
  };

  useEffect(() => {
    if (searchQuery) {
      searchUsers(searchQuery);
    }
  }, [searchQuery]);

  const prevPageRef = useRef(page);
  const prevFilterRef = useRef(filter);

  useEffect(() => {

    const regionRef = collection(db, "regions");
    const regionsData = [];
    getDocs(regionRef)
      .then(async (querySnapshot) => {
        querySnapshot.forEach((docSnapshot) => {
          regionsData.push(docSnapshot.data());
        });
        setRegions(regionsData);
      })
      .catch((error) => {
        console.error("Error getting document: ", error);
      })

    // updateUserAssessment() // run this for db updates only
    const getCurrentMonthDates = () => {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();

      const firstDayOfMonth = new Date(currentYear, currentMonth, 1);
      const currentDay = currentDate.getDate();

      const obj = {
        from: {
          day: 1,
          month: firstDayOfMonth.getMonth() + 1,
          year: firstDayOfMonth.getFullYear(),
        },
        to: {
          day: currentDay,
          month: currentMonth + 1,
          year: currentYear,
        },
      };

      return obj;
    };

    const initialSelectedDayRange = getCurrentMonthDates();
    setSelectedDayRange(initialSelectedDayRange);
    setSelectedEffectiveDayRange(initialSelectedDayRange);
    const currentDate = new Date();

    const date = new Date(currentDate.getFullYear(), currentDate.getMonth());
    const month1 = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const yeardate = `${year}${month1}`;

    setSelectedMonth(yeardate);
  }, []);

  useEffect(() => {
    setIsStatsLoading(true)
    if (!selectedDayRange.from && !selectedDayRange.to) return;
    let q = query(
      collection(db, "users"),
      where("userType", "==", "Candidate"),
      orderBy("test_completion", "desc")
    );

    if (selectedModalRegion && selectedModalRegion !== "All") {
      q = query(q, where("region", "==", selectedModalRegion));
    }

    if (showDatePicker) {
      const sDate = new Date(Date.UTC(selectedDayRange.from.year, selectedDayRange.from.month - 1, selectedDayRange.from.day))
      sDate.setHours(0, 0, 0, 0);
      const eDate = new Date(Date.UTC(selectedDayRange.to.year, selectedDayRange.to.month - 1, selectedDayRange.to.day))
      eDate.setHours(23, 59, 59, 999);
      const startDate = Timestamp.fromDate(sDate);
      const endDate = Timestamp.fromDate(eDate);

      q = query(q, where("test_completion", ">", startDate));
      q = query(q, where("test_completion", "<", endDate));
    } else {
      q = query(q, where("range_month", "==", selectedMonth));
    }

    const q1 = query(q, where("resultStatus", "in", ["Screened"]));
    const q2 = query(q, where("resultStatus", "in", ["Passed"]));
    const q3 = query(q, where("resultStatus", "in", ["Rejected"]));



    Promise.all([getDocs(q1), getDocs(q2), getDocs(q3)]).then((values) => {
      const [screenedSnapshot, passedSnapshot, rejectedSnapshot] = values;

      const countScreened = screenedSnapshot.size;

      const userArrayScreened = screenedSnapshot.docs.map((doc) => {
        const user = doc.data();
        user.id = doc.id;
        return user;
      });
      setUsersScreened(userArrayScreened)

      const countPassed = passedSnapshot.size;
      const userArrayPassed = passedSnapshot.docs.map((doc) => {
        const user = doc.data();
        user.id = doc.id;
        return user;
      });
      setUsersPassed(userArrayPassed)
      const countRejected = rejectedSnapshot.size;
      const userArrayRejected = rejectedSnapshot.docs.map((doc) => {
        const user = doc.data();
        user.id = doc.id;
        return user;
      });
      setUsersRejected(userArrayRejected)
      setStats({
        screened: countScreened,
        passed: countPassed,
        rejected: countRejected,
      });
      setIsStatsLoading(false)
    });
  }, [selectedDayRange, selectedModalRegion, selectedMonth]);

  useEffect(() => {
    const isFilterChange = prevFilterRef.current !== filter;
    let endDoc1 = endDoc;

    if (isFilterChange) {
      endDoc1 = null;
    }

    // Only show full-page spinner on initial load or filter/region changes (when results are cleared)
    // For pagination (scrolling to load more), the InfiniteScroll loader at the bottom handles it
    if (!endDoc1) {
      setIsLoading(true);
    }

    // Always pass the last known region & percentage
    loadData(
      filter,
      selectedFilters,
      selectedRegion.length > 0 ? selectedRegion : prevRegionRef.current,
      percentageScore.length > 0 ? percentageScore : prevPercentageRef.current,
      cefrScore.length > 0 ? cefrScore : prevCefrRef.current,
      endDoc1,
      isFilterChange
    );

    prevPageRef.current = page;
    prevFilterRef.current = filter;
  }, [page, filter, selectedRegion, percentageScore, cefrScore]);

  const generateMonthOptions = () => {
    const currentDate = new Date();
    const options = [];

    for (let i = 0; i < 15; i++) {
      const date = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - i
      );
      const month = date.toLocaleString("default", { month: "short" });
      const month1 = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const label = `${month} - ${year}`;
      options.push(
        <MenuItem key={i} value={`${year}${month1}`}>
          {label}
        </MenuItem>
      );
    }
    return options;
  };

  const handleScreenedClick = async () => {
    setSearchQuery("");
    setFilter("screened");
  };

  const handleNotScreenedClick = async () => {
    setSearchQuery("");
    setFilter("not_screened");
  };

  const handleGenerateCodeClick = () => {
    history("/addCandidate");
  };

  const handleCodeGeneratedClick = async (e) => {
    setSearchQuery("");
    if (e.target.checked) {
      setFilter("codeGenerated");
      setActiveFilter("codeGenerated");
    } else {
      setFilter("");
      setActiveFilter(null);
    }
  };

  // Called by InfiniteScroll when user scrolls near the bottom
  const loadMore = () => {
    if (isLoadingRef.current) return;
    isLoadingRef.current = true; // Guard against multiple triggers
    setPage((prevPage) => prevPage + 1);
  };

  const handleMonthFilter = (event) => {
    const month = event.target.value;
    setSelectedMonth(month);
  };

  const handleRegionChange = (event) => {
    const value = event.target.value;
    setSelectedModalRegion(value);
  };

  // Removed manual window scroll listener — InfiniteScroll component handles pagination now

  const prevRegionRef = useRef([]);
  const prevPercentageRef = useRef([]);
  const prevCefrRef = useRef([]);

const handleFilterChange = (event, isChecked, isRegion, isPercentage, isCefr) => {
  
  if(isPercentage) {
    setActiveFilter("percentage")
  }
  if(isCefr) {
    setActiveFilter("cefr")
  }

  let updatedFilters = [...selectedFilters];
  const value = Array.isArray(event.target.value) ? event.target.value : [event.target.value];

  let region = selectedRegion;
  let percentage = percentageScore;
  let cefr = cefrScore;

  // if (isRegion) {
  //        setSelectedRegion(value);
  //     region = value;
  //   prevRegionRef.current = region;
  // } 
  
  
  if (isRegion) {
    let newValues = Array.isArray(event.target.value)
      ? event.target.value
      : [event.target.value];
  
    // Enforce limit of 5 regions
    if (newValues.length > 5) {
      // Keep only the last 5 selected
      newValues = newValues.slice(newValues.length - 5);
    }
  
    setSelectedRegion(newValues);
    region = newValues;
    prevRegionRef.current = newValues;
  }
  
  
  

  if (isPercentage) {
    setPercentageScore(value);
    percentage = value;
    prevPercentageRef.current = percentage;
  
    if (value.length === 0) {
      setActiveFilter(null);
    } else {
      setActiveFilter("percentage");
    }
  }

  if (isCefr) {
    setCefrScore(value);
    cefr = value;
    prevCefrRef.current = cefr;
  
    if (value.length === 0) {
      setActiveFilter(null); // Re-enable other filters
    } else {
      setActiveFilter("cefr"); // Disable others when CEFR is selected
    }
  }

  // Update regular filters (not region/percentage)
  if (!isRegion && !isPercentage) {
    value.forEach((v) => {
      if (updatedFilters.includes(v)) {
        updatedFilters = updatedFilters.filter((filter) => filter !== v);
      } else {
        updatedFilters.push(v);
      }
    });
    setSelectedFilters(updatedFilters);
  }

  // Ensure both filters are applied together
  loadData(filter, updatedFilters, prevRegionRef.current, prevPercentageRef.current, prevCefrRef.current, null, true);
};

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  function getMonthAbbreviation(month) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[month - 1];
  }

  function padNumber(number) {
    return number.toString().padStart(2, "0");
  }

  function getTwoDigitYear(year) {
    return year.toString().slice(-2);
  }

  const formatInputValue = () => {
    if (selectedDayRange.from && selectedDayRange.to) {
      const from = selectedDayRange.from;
      const to = selectedDayRange.to;
      const formattedDate = `${getMonthAbbreviation(from.month)}/${padNumber(
        from.day
      )}/${getTwoDigitYear(from.year)} - ${getMonthAbbreviation(
        to.month
      )}/${padNumber(to.day)}/${getTwoDigitYear(to.year)}
      `;

      return formattedDate;
    } else {
      return "Select Date Range";
    }
  };

  const getFilterTypes = (isModal) => {
    return (
      <SoftBox
        display="flex"
        flexDirection={isMobile ? "column" : "row"}
        sx={{ paddingTop: "10px", marginBottom: "20px", display: 'flex' }}
      >
        <SoftBox
          display="flex"
          flexDirection="row"
          style={{ paddingRight: isMobile ? "0px" : "0px", flex: 0.195 }}
        >
          <FormControl
            size="small"
            sx={{
              marginBottom: isMobile ? "8px" : "0",
              width: isMobile ? "100%" : "200px",
            }}
          >


            <Select
              multiple
              displayEmpty
              value={selectedRegion}
              ref={selectRef1}
              onOpen={() => setFilterOpen1(true)}
              onClose={() => setFilterOpen1(false)}
              open={filterOpen1}
              onChange={(event) => handleFilterChange(event, false, true, false, false)}
              renderValue={(selected) =>
                selected.length === 0 ? "Regions" : selected.join(", ")
              }
              style={{
                paddingRight: "1px !important",
                border: "1px solid #BCB0B3"
              }}
              sx={{
                color: "#848484 !important",
                fontWeight: "400",
                fontSize: "1rem !important",
                backgroundColor: "#F7F7F7 !important",
                "& .MuiSelect-select": {
                  minWidth: isMobile ? "100%" : "140px",
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: "#F7F7F7 !important",
                    border: "1px solid yellow !important",
                    borderRadius: "8px",
                    border: "1px solid #BCB0B3",
                    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                    marginTop: "15px"
                  },
                },
              }}
            >
              {/* <MenuItem value="All">
                <Checkbox 
                  checked={selectedRegion.length === regions.length}
                  sx={{
                    color: "#42393C",
                    "&.Mui-checked": {
                      background: "none",
                      borderRadius: "4px",
                      border: "1px solid #5569ED",
                      backgroundColor: "#F7F7F7 !important"

                    },
                    "&.Mui-selected": {
                      backgroundColor: "red !important"

                    },
                    fontWeight: "400",
                    width:"16px",
                    height:"16px",
                    borderRadius: "4px",
                    backgroundColor: "#F7F7F7 !important"
                  }}
                  icon={
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#DADADA"/>
                      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#CECECE"/>
                    </svg>
                  }
                  checkedIcon={
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path d="M10 3L4.5 8.5L2 6" stroke="#5569ED" stroke-width="1.6666" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>}
                />
                All
              </MenuItem> */}
    
              {regions
                .filter((regionData) => regionData.show_dropdown)
                .map((regionData) => (
                <MenuItem key={regionData.region} value={regionData.region}>
                  <Checkbox 
                    checked={selectedRegion.includes(regionData.region)}
                    sx={{
                      color: "#42393C",
                      "&.Mui-checked": {
                        background: "none",
                        borderRadius: "4px",
                        border: "1px solid #5569ED",
                        backgroundColor: "#F7F7F7 !important"

                      },
                      "&.Mui-selected": {
                        backgroundColor: "red !important"

                      },
                      fontWeight: "400",
                      width:"16px",
                      height:"16px",
                      borderRadius: "4px",
                      backgroundColor: "#F7F7F7 !important"
                    }}
                    icon={
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#DADADA"/>
                        <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#CECECE"/>
                      </svg>
                    }
                    checkedIcon={
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M10 3L4.5 8.5L2 6" stroke="#5569ED" stroke-width="1.6666" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>}
                  />
                  {regionData.name}
                </MenuItem>
              ))}
            </Select>




          </FormControl>
        </SoftBox>
    
        <SoftBox
          display="flex"
          flexDirection="row"
          style={{ paddingRight: isMobile ? "0px" : "0px", flex: 0.195 }}
        >
          <FormControl
            size="small"
            sx={{
              marginBottom: isMobile ? "8px" : "0",
              width: isMobile ? "100%" : "200px",
            }}
          >
            <Select
              multiple
              displayEmpty
              value={cefrScore}
              ref={selectRef2}
              onOpen={() => setFilterOpen2(true)}
              onClose={() => setFilterOpen2(false)}
              open={filterOpen2}
              onChange={(event) => {
                handleFilterChange(event, false, false, false, true);
              }}
              renderValue={(selected) => {
                if (selected.length === 0) return "CEFR Score";
    
                return selected
                  .map((value) => {
                    switch (value) {
                      case "C2":
                        return "C2";
                      case "C1":
                        return "C1";
                      case "B2":
                        return "B2";
                      case "B1":
                        return "B1";
                      case "A2":
                        return "A2";
                      case "A1":
                        return "A1";
                      default:
                        return value;
                    }
                  })
                  .join(", ");
              }}
              style={{
                fontSize: "1rem",
                color: "inherit",
                paddingRight: "1px !important",
                border: "1px solid #BCB0B3"
              }}
              sx={{
                color: "#848484 !important",
                fontWeight: "400",
                fontSize: "1rem !important",
                backgroundColor: "#F7F7F7 !important",
                "&.Mui-disabled": {
                  cursor: "not-allowed !important",
                  "& .MuiSelect-select": {
                    cursor: "not-allowed !important",
                  },
                },
                "& .MuiSelect-select": {
                  minWidth: isMobile ? "100%" : "140px",
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: "#F7F7F7 !important",
                    border: "1px solid yellow !important",
                    borderRadius: "8px",
                    border: "1px solid #BCB0B3",
                    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                    marginTop: "15px"
                  },
                },
              }}
              disabled={activeFilter !== null && activeFilter !== "cefr"}
            >
              {[
                { value: "C2", label: "C2" },
                { value: "C1", label: "C1" },
                { value: "B2", label: "B2" },
                { value: "B1", label: "B1" },
                { value: "A2", label: "A2" },
                { value: "A1", label: "A1" },
              ].map((score) => (
                <MenuItem key={score.value} value={score.value} style={{minWidth: "100px !important", padding: "0 4px !important"}}>
                  <Checkbox 
                    checked={cefrScore.includes(score.value)}
                    sx={{
                      color: "#42393C",
                      "&.Mui-checked": {
                        background: "none",
                        borderRadius: "4px",
                        border: "1px solid #5569ED",
                        backgroundColor: "#F7F7F7 !important"
                      },
                      fontWeight: "400",
                      width:"16px",
                      height:"16px",
                      borderRadius: "4px",
                      backgroundColor: "#F7F7F7 !important"
                    }}
                    icon={
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#DADADA"/>
                        <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#CECECE"/>
                      </svg>
                    }
                    checkedIcon={
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M10 3L4.5 8.5L2 6" stroke="#5569ED" stroke-width="1.6666" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>}
                  />
                  {score.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </SoftBox>
    
        <SoftBox display="flex" flexDirection="row" style={{ paddingRight: isMobile ? "0px" : "0px", flex: 0.195 }}>
          <FormControl
            size="small"
            sx={{
              marginBottom: isMobile ? "8px" : "0",
              width: isMobile ? "100%" : "200px",
            }}
          >
            <Select
              multiple
              displayEmpty
              value={percentageScore}
              ref={selectRef3}
              onOpen={() => setFilterOpen3(true)}
              onClose={() => setFilterOpen3(false)}
              open={filterOpen3}
              onChange={(event) => handleFilterChange(event, false, false, true, false)}
              renderValue={(selected) => {
                if (selected.length === 0) return "% Score";
                return selected
                  .map((value) => {
                    switch (value) {
                      case 0:
                        return "0-20%";
                      case 20:
                        return "21-40%";
                      case 40:
                        return "41-60%";
                      case 60:
                        return "61-80%";
                      case 80:
                        return "81-100%";
                      default:
                        return value;
                    }
                  })
                  .join(", ");
              }}
              style={{
                fontSize: "1rem",
                color: "inherit",
                paddingRight: "1px !important",
                border: "1px solid #BCB0B3",
              }}
              sx={{
                color: "#848484 !important",
                fontWeight: "400",
                fontSize: "1rem !important",
                backgroundColor: "#F7F7F7 !important",
                "&.Mui-disabled": {
                  cursor: "not-allowed !important",
                  "& .MuiSelect-select": {
                    cursor: "not-allowed !important",
                  },
                },
                "& .MuiSelect-select": {
                  minWidth: isMobile ? "100%" : "140px",
                },
              }}
              disabled={activeFilter !== null && activeFilter !== "percentage"}
              MenuProps={{
                PaperProps: {
                  sx: {
                    backgroundColor: "#F7F7F7 !important",
                    borderRadius: "8px",
                    border: "1px solid #BCB0B3",
                    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                    marginTop: "15px"
                  },
                },
              }}
            >
              {[
                { value: 0, label: "0-20%" },
                { value: 20, label: "21-40%" },
                { value: 40, label: "41-60%" },
                { value: 60, label: "61-80%" },
                { value: 80, label: "81-100%" },
              ].map((score) => (
                <MenuItem key={score.value} value={score.value}>
                  <Checkbox
                    checked={percentageScore.includes(score.value)}
                    sx={{
                      color: "#42393C",
                      "&.Mui-checked": {
                        background: "none",
                        borderRadius: "4px",
                        border: "1px solid #5569ED",
                        backgroundColor: "#F7F7F7 !important",
                      },
                      fontWeight: "400",
                      width: "16px",
                      height: "16px",
                      borderRadius: "4px",
                      backgroundColor: "#F7F7F7 !important",
                    }}
                    icon={
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#DADADA" />
                        <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="#CECECE" />
                      </svg>
                    }
                    checkedIcon={
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M10 3L4.5 8.5L2 6" stroke="#5569ED" strokeWidth="1.6666" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    }
                  />
                  {score.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </SoftBox>
    
      {/* <Tooltip
        title="Disabled when other filters are active"
        disableHoverListener={activeFilter === null || activeFilter === "codeGenerated"}
      > */}
        <SoftBox
          display="flex"
          flexDirection="row"
          sx={{ width: "100%", opacity: 0.9, flex: "0.2", marginLeft: "10px" }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={filter === "codeGenerated"}
                onChange={handleCodeGeneratedClick}
                value="codeGenerated"
                disabled={activeFilter !== null && activeFilter !== "codeGenerated"}
                style={{ backgroundColor: "white" }}
                sx={{
                  "&.Mui-disabled": {
                    cursor: "not-allowed !important",
                  },
                  "&.Mui-disabled .MuiSvgIcon-root": {
                    cursor: "not-allowed !important",
                  },
                  "&.Mui-disabled input": {
                    cursor: "not-allowed !important",
                  },
                  "&.Mui-disabled:hover": {
                    cursor: "not-allowed !important",
                  },
                  "&.Mui-disabled:hover .MuiSvgIcon-root": {
                    cursor: "not-allowed !important",
                  },
                  "&.Mui-disabled:hover input": {
                    cursor: "not-allowed !important",
                  }
                }}
              />
            }
            label="Code Generated Only"
            componentsProps={{
              typography: {
                sx: {
                  color: "#42393C !important",
                  fontWeight: "400 !important",
                  fontSize: "16px !important",
                  cursor:
                    activeFilter !== null && activeFilter !== "codeGenerated"
                      ? "not-allowed !important"
                      : "pointer",
                },
              },
            }}
            sx={{
              cursor:
                activeFilter !== null && activeFilter !== "codeGenerated"
                  ? "not-allowed !important"
                  : "pointer",
            }}
          />
        </SoftBox>
      {/* </Tooltip> */}
    
        <SoftBox
          display="flex"
          flexDirection="row"
          justifyContent="flex-end"
          flexGrow="1"
          ml="auto"
          style={{ alignItems: "center", flex: 0.2 }}
        >
          <SoftButton
            color="gt_primary"
            onClick={handleGenerateCodeClick}
            sx={{ width: isMobile ? "100%" : "135px", textTransform: 'none', fontSize: '14px', fontWeight: '600', padding: '0' }}
          >
            Add Candidate
          </SoftButton>
        </SoftBox>
      </SoftBox>
    );
    
  };

  const getModalFilter = () => {
    return (
      <SoftBox
        display="flex"
        // alignItems="center"
        flexDirection={isMobile ? "column" : "row"}
        gap={isMobile ? "0px" : "8px"}
        sx={{ marginBottom: 1 }}
        style={{ width: "100%", paddingTop: "5px" }}
      >
        <SoftBox display="flex" flexDirection="row">
          <FormControl
            size="small"
            sx={{
              marginBottom: isMobile ? "8px" : "0",
              width: isMobile ? "100%" : "200px",
              minWidth: isMobile ? "100%" : "200px",
            }}>
            <InputLabel
              sx={{
                bgcolor: 'snow',
              }}
              style={{
                fontSize: "1rem", color: "inherit",
                zIndex: 1,
                backgroundColor: "white !important",
                paddingRight: "5px",
                paddingLeft: "3px"
              }}>
              Region
            </InputLabel>

            <Select
              onChange={(event) => handleRegionChange(event)}
              value={selectedModalRegion}
              style={{
                fontSize: "1rem",
                color: "inherit",
                paddingRight: "1px !important",
              }}
              sx={{
                "& .MuiSelect-select": {
                  minWidth: isMobile ? "100%" : "150px",
                },
              }}
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="IND">India</MenuItem>
              <MenuItem value="DR">Dominican Republic</MenuItem>
              <MenuItem value="PHIL">Phillippines</MenuItem>
            </Select>
          </FormControl>
        </SoftBox>
        <SoftBox
          display="flex"
          flexDirection="row"
          sx={{ marginBottom: 1 }}
        // style={{ paddingRight: "16px" }}
        >
          {showDatePicker ? (
            <div
              style={{
                fontSize: "1rem !important",
                width: isMobile ? "100%" : "200px !important",
                minWidth: isMobile ? "100%" : "200px !important",
              }}
            >
              <DatePicker
                id="customDatePicker"
                value={selectedEffectiveDayRange}
                onChange={(e) => {
                  setSelectedEffectiveDayRange(e);
                  if (e.from !== null && e.to !== null) setSelectedDayRange(e);
                }}
                formatInputText={formatInputValue}
                inputPlaceholder="Select Range"
                calendarClassName="responsive-calendar"
                colorPrimary="#371D66"
                colorPrimaryLight="#FF7300"
                shouldHighlightWeekends
              />
            </div>
          ) : (
            <FormControl
              size="small"
              sx={{
                marginBottom: isMobile ? "8px" : "0",
                width: isMobile ? "100%" : "200px",
                minWidth: isMobile ? "100%" : "200px",
              }}
            >
              <InputLabel
                sx={{
                  bgcolor: 'snow',
                }}
                style={{
                  fontSize: "1rem", color: "inherit", zIndex: 1,
                  backgroundColor: "white !important",
                  paddingRight: "5px",
                  paddingLeft: "3px"
                }}>
                Month
              </InputLabel>

              <Select
                onChange={handleMonthFilter}
                value={selectedMonth}
                style={{
                  fontSize: "1rem",
                  color: "inherit",
                  paddingRight: "1px !important",
                }}
                sx={{
                  "& .MuiSelect-select": {
                    minWidth: isMobile ? "100%" : "150px",
                  },
                }}
              >
                {generateMonthOptions()}
              </Select>
            </FormControl>
          )}
          <SwapHorizIcon
            style={{ float: "right", cursor: "pointer" }}
            onClick={toggleDatePicker}
          />
        </SoftBox>
      </SoftBox>
    );
  };
  const CardList = () => {
    return (
      <>
        <InfiniteScroll
          dataLength={users.length}
          next={loadMore}
          hasMore={hasMore}
          loader={getLoader()}
          endMessage={<h6></h6>}
          style={{ background: "rgba(243, 243, 243, 1)" }}
        >
          <>
            <SoftBox px={0}>
              <SoftBox
                component="ul"
                display="flex"
                flexDirection="column"
                p={0}
                m={0}
                mb={4}
                sx={{backgroundColor:"rgba(243, 243, 243, 1) !important"}}
              >
                {users.map((user) => {
                  return (
                    <Link
                      to={`/details/${user.id}`}
                      style={{ textDecoration: "none", marginBottom: "8px" }}
                    >
                      <CardLayout1 row={user} />
                    </Link>
                  );
                })}
              </SoftBox>
            </SoftBox>
          </>
          <div></div>
        </InfiniteScroll>
      </>
    );
  };

  const handleSearchQuery = (txt) => {
    setFilter("");
    setSearchQuery(txt);
  };
  if (isLoading) {
    return (

      <div className="spinner">
        {/* {getLoader()} */}
        <MySpinner />
      </div>
    );
  }

  return (
    <div>
      <Banner linkTxt="/candidates" showLogoutButton={true} handleOpen={handleOpen} />
      <Container>
        <SearchBar
          onSubmit={handleSearchQuery}
          onClearQuery={handleSearchQuery}
        />
        {getFilterTypes()}
        {/* <FilterBar setSearchQuery={setSearchQuery} /> */}
        <div className="mobile">
          <CardList />

          {/* <Container
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              width: "auto",
              // opacity: 0.8,
              marginRight: "1.5rem",
              color: "white",
              height: "3rem",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 1rem",
              position: "fixed",
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 999,
            }}
          >
            <SoftBox
              sx={{
                display: "flex",
                width: "33.33%",
                height: "100%",
                margin: "0 0.25rem",
              }}
            >
              <SoftButton
                // color={"gt_primary"}
                color={filter === "screened" ? "gt_secondary" : "gt_primary"}
                onClick={handleScreenedClick}
                sx={{ width: "100%" }}
              >
                Screened
              </SoftButton>
            </SoftBox>
            <SoftBox
              sx={{
                display: "flex",
                width: "33.33%",
                height: "100%",
                margin: "0 0.25rem",
              }}
            >
              <SoftButton
                color={filter === "not_screened" ? "gt_secondary" : "gt_primary"}
                // color={"gt_primary"}
                // variant="text"
                // variant="gradient"
                onClick={handleNotScreenedClick}
                sx={{ width: "100%" }}
              >
                Not Screened
              </SoftButton>
            </SoftBox>
            <SoftBox
              sx={{
                display: "flex",
                width: "33.33%",
                height: "100%",
                margin: "0 0.25rem",
              }}
            >
              <SoftButton
                color="gt_primary"
                // variant="gradient"
                onClick={handleGenerateCodeClick}
                sx={{ width: "100%" }}
              >
                Add Candidate
              </SoftButton>
            </SoftBox>
          </Container> */}
        </div>
      </Container>
      {getModalDiv()}
    </div>
  );
};

export default CandidateList;